import React from 'react';

// Country code to Twemoji flag image mapping
// Using Twemoji CDN for cross-browser flag support (Chrome Windows doesn't render flag emojis)
const FLAG_IMAGES = {
  'US': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1fa-1f1f8.svg',
  'ES': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ea-1f1f8.svg',
  'FR': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1eb-1f1f7.svg',
  'DE': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1e9-1f1ea.svg',
  'BR': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1e7-1f1f7.svg',
  'IT': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ee-1f1f9.svg',
  'CN': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1e8-1f1f3.svg',
  'TW': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f9-1f1fc.svg',
  'JP': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ef-1f1f5.svg',
  'KR': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f0-1f1f7.svg',
  'SA': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f8-1f1e6.svg',
  'RU': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f7-1f1fa.svg',
  'TR': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f9-1f1f7.svg',
  'NL': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f3-1f1f1.svg',
  'PL': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f5-1f1f1.svg',
  'IN': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ee-1f1f3.svg',
  'VN': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1fb-1f1f3.svg',
  'ID': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ee-1f1e9.svg',
  'TH': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f9-1f1ed.svg',
  'UA': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1fa-1f1e6.svg',
  'HU': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1ed-1f1fa.svg',
  'RO': 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f7-1f1f4.svg',
};

// FlagEmoji component - renders flag as Twemoji image for cross-browser support
export default function FlagEmoji({ flag, shortCode, className = '', size = 16 }) {
  const flagUrl = FLAG_IMAGES[shortCode];

  if (flagUrl) {
    return (
      <img
        src={flagUrl}
        alt={flag}
        className={className}
        style={{
          width: size,
          height: size,
          display: 'inline-block',
          verticalAlign: 'middle'
        }}
      />
    );
  }

  // Fallback to emoji if no image URL
  return (
    <span className={className}>
      {flag}
    </span>
  );
}

// For use in NATIVE <select>/<option> elements only
// Images can't be used in native selects, so use country code
export function getFlagDisplayForSelect(flag, shortCode) {
  const isChrome = typeof navigator !== 'undefined' && /Chrome/.test(navigator.userAgent);
  const isWindows = typeof navigator !== 'undefined' && /Windows/.test(navigator.userAgent);

  if (isChrome && isWindows && shortCode) {
    return `[${shortCode}]`;
  }
  return flag;
}

// For use in custom dropdowns (divs/buttons) - returns JSX with Twemoji image
export function getFlagDisplay(flag, shortCode) {
  const flagUrl = FLAG_IMAGES[shortCode];

  if (flagUrl) {
    return (
      <img
        src={flagUrl}
        alt={flag}
        style={{
          width: 16,
          height: 16,
          display: 'inline-block',
          verticalAlign: 'middle'
        }}
      />
    );
  }

  return flag;
}
